"use client";

import React from "react";
import { GripVertical } from "lucide-react";

interface SplitHandleProps {
    onMouseDown: () => void;
    onTouchStart: () => void;
    onKeyDown: (e: React.KeyboardEvent) => void;
    onDoubleClick?: () => void;
    ariaLabel?: string;
    percent: number;
    isDragging?: boolean;
}

export default function SplitHandle({
    onMouseDown,
    onTouchStart,
    onKeyDown,
    onDoubleClick,
    ariaLabel = "Resize panels",
    percent,
    isDragging,
}: SplitHandleProps) {
    return (
        <div
            role="separator"
            aria-orientation="vertical"
            aria-label={ariaLabel}
            aria-valuenow={Math.round(percent)}
            aria-valuemin={0}
            aria-valuemax={100}
            tabIndex={0}
            onMouseDown={onMouseDown}
            onTouchStart={onTouchStart}
            onKeyDown={onKeyDown}
            onDoubleClick={onDoubleClick}
            title="Drag to resize · double-click to reset"
            className={
                "hidden md:flex relative w-3 shrink-0 cursor-col-resize items-center justify-center group focus:outline-none select-none" +
                (isDragging ? " bg-blue-100 dark:bg-blue-950" : "")
            }
        >
            <div
                className={
                    "w-1 h-10 rounded-full transition-colors " +
                    (isDragging
                        ? "bg-blue-500"
                        : "bg-gray-300 dark:bg-gray-600 group-hover:bg-blue-400 group-focus:bg-blue-500")
                }
            />
            <GripVertical
                className="w-3 h-3 text-gray-400 dark:text-gray-500 absolute opacity-0 group-hover:opacity-100 transition-opacity"
                aria-hidden="true"
            />
        </div>
    );
}
